import { DrawerProps } from '@/components/Layout/Drawer';

import { useAppSelector } from '@/hooks/redux';

import { selectOperationUser } from '@/redux/operation/selectors';

import { MinorQuestionsDrawer } from './QuestionsDrawer/MinorQuestionsDrawer';

interface MinorBasicInfoDrawerProps extends DrawerProps {
  user: import('@/types/user').User;
}

export function MinorBasicInfoDrawer({
  open,
  onClose,
  user,
}: Readonly<MinorBasicInfoDrawerProps>) {
  const minorUser = useAppSelector(selectOperationUser);

  if (!minorUser) return null;

  return <MinorQuestionsDrawer open={open} onClose={onClose} user={user} />;
}
